import { navigate } from 'gatsby'

const availabilitySubmit = async ({ values }) => {
  try {
    const response = await fetch(
      `https://m.clear.link/zip_code/${values.zip_postal}`
    )
    const data = await response.json()
    const state = data.data.zipCodes[0].state.toLowerCase()
    const city = data.data.zipCodes[0].city.toLowerCase()
    const finalCity = city.split(' ').join('-')

    navigate(`/${state}/${finalCity}`)
  } catch (error) {
    console.error('Error occurred:', error)
  }
}

export default availabilitySubmit
